import * as _ from 'lodash';
import { CustomColorTheme } from "./custom-color-theme.model";
import { Organization } from "./organization.model";
import { PageBlockCampaign } from "./page-blocks/page-block-campaign.model";
import { PageBlockFAQ } from "./page-blocks/page-block-faq.model";
import { PageBlockImage } from "./page-blocks/page-block-image.model";
import { PageBlockLiveAuction } from "./page-blocks/page-block-live-auction.model";
import { PageBlockSilentAuction } from "./page-blocks/page-block-silent-auction.model";
import { PageBlockSlides } from "./page-blocks/page-block-slides.model";
import { PageBlockText } from "./page-blocks/page-block-text.model";
import { PageBlockVideo } from "./page-blocks/page-block-video.model";
import { Registration } from './registration.model';

export class EventPageConfig {

    public coverImage = null;
    public created = null;
    public customThemeId = null;
    public desc = null;
    public designTemplate = null;
    public eventId = null;
    public eventType = null;
    public hideInPerson = null;
    public hideSponsors = null;
    public hideDateTime = null;
    public customDateTimeLabel = null;
    public hideShareButtons = null;
    public registrationButtonLabelRequired = null;
    public registrationButtonLabel = null;
    public hideVirtual = null;
    public id = null;
    public layout = null;
    public name = null;
    public owner = null;
    public sponsors = [];
    public templateType = null;
    public updated = null;
    public url = null;

    public customColorTheme = null;
    public orgInfo = null;
    public pageBlocks = [];
    public registrations = [];
    public hybridEventInfo = null;
    public inPersonEventInfo = null;
    public virtualEventInfo = null;

    constructor(eventPageConfig) {
        this.coverImage = eventPageConfig.coverImage;
        this.created = eventPageConfig.created;
        this.customThemeId = eventPageConfig.customThemeId;
        this.desc = eventPageConfig.desc;
        this.designTemplate = eventPageConfig.designTemplate;
        this.eventId = eventPageConfig.eventId;
        this.eventType = eventPageConfig.eventType;
        this.hideInPerson = eventPageConfig.hideInPerson;
        this.hideSponsors = eventPageConfig.hideSponsors;
        this.hideDateTime = eventPageConfig.hideDateTime;
        this.customDateTimeLabel = eventPageConfig.customDateTimeLabel;
        this.hideShareButtons = eventPageConfig.hideShareButtons;
        this.registrationButtonLabelRequired = eventPageConfig.registrationButtonLabelRequired;
        this.registrationButtonLabel = eventPageConfig.registrationButtonLabel || 'Register';
        this.hideVirtual = eventPageConfig.hideVirtual;
        this.id = eventPageConfig.id;
        this.layout = eventPageConfig.layout;
        this.name = eventPageConfig.name;
        this.owner = eventPageConfig.owner;
        this.sponsors = eventPageConfig.sponsors || [];
        this.templateType = eventPageConfig.templateType;
        this.updated = eventPageConfig.updated;
        this.url = eventPageConfig.url;
        this.hybridEventInfo = eventPageConfig.hybridEventInfo;
        this.inPersonEventInfo = eventPageConfig.inPersonEventInfo;
        this.virtualEventInfo = eventPageConfig.virtualEventInfo;

        this.customColorTheme = new CustomColorTheme(eventPageConfig.customColorTheme || null);
        this.orgInfo = new Organization(eventPageConfig.orgInfo);
        this.pageBlocks = eventPageConfig.pageBlocks.map(pageBlock => {
            switch (pageBlock.type) {
              case 1:
                return new PageBlockText(pageBlock);
              case 2:
                return new PageBlockFAQ(pageBlock);
              case 3:
                return new PageBlockSlides(pageBlock);
              case 4:
                return new PageBlockCampaign(pageBlock);
              case 5:
                return new PageBlockSilentAuction(pageBlock);
              case 6:
                return new PageBlockLiveAuction(pageBlock);
              case 7:
                return new PageBlockVideo(pageBlock);
              case 8:
                return new PageBlockImage(pageBlock);
            }
        });

        this.registrations = eventPageConfig.registrations.map(registration => {
          return new Registration(registration);
        });

    }

    setThemeColors() {
      if(this.customColorTheme.id) {
        this.customColorTheme.setThemeColors();
      }
    }

    getCoverImage() {
      let coverImage = '';
  
      if (this.coverImage !== '') {
          return this.coverImage;
      }
  
      if (this.eventType === 1) {
        coverImage = this.coverImage !== '' ? this.coverImage : this.virtualEventInfo.imageUrl;
      }
  
      if (this.eventType === 0) {
        coverImage = this.coverImage !== '' ? this.coverImage : this.inPersonEventInfo.image;
      }
  
      if (this.eventType === 2) {
        coverImage = this.coverImage !== ''
          ? this.coverImage : this.hybridEventInfo.imageUrl || this.hybridEventInfo.virtualEvent.imageUrl || this.hybridEventInfo.inPersonEvent.image;
      }
  
      return coverImage === '' ? '/images/blank_2x1.png' : coverImage;
    }

    getHeaderType() {
        let headerType = 1;

        if (this.templateType === 10 && this.customColorTheme.id) {
            headerType = this.customColorTheme.headerType;
        }
      
        const layoutHeaderType = _.get(this.layout, 'headerType', null);
        headerType = layoutHeaderType ? layoutHeaderType : headerType;

        return headerType;
    }

    getMenu() {
        const result = [];

        this.pageBlocks.forEach((pageBlock, index) => {
            const url = window.location.origin + window.location.pathname;

            if(pageBlock.removeFromNav === true) {
                return null;
            }

            const menuElement = pageBlock.getMenuElement(url, index);
            if(menuElement) {
                result.push(menuElement);
            }
        });

        return result;
    }

    isAllRegistrationsDisabled() {
      const allButtonsCount = this.registrations.length;
      let disabledButtons = 0;

      this.registrations.forEach(button => {
        if(button.disabledButton()) {
          disabledButtons++;
        }
      });

      return disabledButtons === allButtonsCount;
    }
}